import { EducationRecordModel } from '@shared/data-access/models';
import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { map, Observable } from 'rxjs';
import { IEducationRecord } from '@shared/data-access/interfaces';
import { EducationalRecordDto } from '@shared/data-access/dto';

@Injectable({
  providedIn: 'root',
})
export class EducationRecordApiService {
  static EDUCATION_RECORD = 'hrm/educations';

  constructor(private apiService: ApiService) {}

  create(salespersonId: number, data: EducationalRecordDto): Observable<EducationRecordModel> {
    return this.apiService
      .post(`${EducationRecordApiService.EDUCATION_RECORD}/${salespersonId}`, data)
      .pipe(map((res: IEducationRecord) => EducationRecordModel.fromJson(res) as EducationRecordModel));
  }

  update(id: number, data: EducationalRecordDto): Observable<any> {
    return this.apiService.patch(EducationRecordApiService.EDUCATION_RECORD + '/' + id, data, { excludeFields: [''] });
  }

  getAll(salespersonId: number, query = {}, option?: IApiOption): Observable<EducationRecordModel[]> {
    // return of(fakeData.map(item =>  AdditionalInformationModel.fromJson(item)));
    return this.apiService
      .get(`${EducationRecordApiService.EDUCATION_RECORD}/${salespersonId}`, query, option)
      .pipe(map((data: IEducationRecord[]) => data.map(item => EducationRecordModel.fromJson(item))));
  }

  delete(id: number, option?: IApiOption): Observable<any> {
    return this.apiService.delete(EducationRecordApiService.EDUCATION_RECORD + '/' + id, {}, option);
  }
}
